/* bmcW2D.js: swarm wave 2 (W2D, 2026-09-28) on the default product template. Loaded only by sections/main-product.liquid
   for non-frozen products, never on a landing page.
   1 click to play: a facade button swaps in the player only after a tap (YouTube nocookie or Vimeo, autoplay on the tap,
     class js-youtube / js-vimeo so Dawn's pauseAllMedia pauses it when the shopper picks another image)
   2 "Watch a sample" link under the title: opens the sample slide in the gallery and plays it
   3 larger view of an extra gallery page in a native dialog (Esc, the close button or a tap outside closes it)
   4 play window for the coaching client videos: data-bmcw2d-min / data-bmcw2d-max (seconds). The embed's #t= starts the
     video at min; through the Vimeo player API (postMessage) a seek before min snaps back to min, and at max the video
     pauses and goes back to min. Those windows keep the clients' surnames and the program end cards off screen. */
(function () {
  if (window.bmcW2DInit) return;
  window.bmcW2DInit = true;

  var VIMEO = 'https://player.vimeo.com', wins = [];
  function vpost(f, method, value) {
    try { f.contentWindow.postMessage(JSON.stringify(value === undefined ? { method: method } : { method: method, value: value }), VIMEO); } catch (e) {}
  }
  function vlisten(f) { vpost(f, 'addEventListener', 'timeupdate'); vpost(f, 'addEventListener', 'seeked'); }
  window.addEventListener('message', function (e) {
    if (e.origin !== VIMEO || !wins.length) return;
    var w = null;
    for (var i = 0; i < wins.length; i++) if (wins[i].f.contentWindow === e.source) w = wins[i];
    if (!w) return;
    var d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
    if (!d || !d.event) return;
    if (d.event === 'ready') { vlisten(w.f); return; }
    if ((d.event === 'timeupdate' || d.event === 'seeked' || d.event === 'playProgress') && d.data && typeof d.data.seconds === 'number') {
      var s = d.data.seconds;
      if (w.max && s >= w.max) { vpost(w.f, 'pause'); vpost(w.f, 'setCurrentTime', w.min || 0); }
      else if (w.min && s < w.min - 0.25) vpost(w.f, 'setCurrentTime', w.min);
    }
  });

  function load(box) {
    if (!box || box.getAttribute('data-bmcw2d-on')) return;
    var src = box.getAttribute('data-bmcw2d-embed');
    if (!src) return;
    if (typeof window.pauseAllMedia === 'function') { try { window.pauseAllMedia(); } catch (e) {} }
    var f = document.createElement('iframe');
    f.src = src;
    f.title = box.getAttribute('data-bmcw2d-title') || 'Video';
    f.className = box.getAttribute('data-bmcw2d-host') === 'youtube' ? 'js-youtube' : 'js-vimeo';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    box.setAttribute('data-bmcw2d-on', '1');
    box.classList.add('is-on');
    var b = box.querySelector('.bmcW2D-vplay');
    if (b) b.remove();
    var min = parseFloat(box.getAttribute('data-bmcw2d-min')) || 0, max = parseFloat(box.getAttribute('data-bmcw2d-max')) || 0;
    if (f.className === 'js-vimeo' && (min || max)) {
      wins.push({ f: f, min: min, max: max });
      f.addEventListener('load', function () { vlisten(f); });
    }
    box.appendChild(f);
    try { f.focus({ preventScroll: true }); } catch (e) {}
  }

  var dlg = null, last = null;
  function zoom(btn) {
    var src = btn.getAttribute('data-bmcw2d-zoom');
    if (!src) return;
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'bmcW2D-dlg';
      dlg.setAttribute('aria-label', 'Larger view');
      dlg.innerHTML = '<button type="button" class="bmcW2D-dlg__x" aria-label="Close the larger view">&times;</button><img alt="">';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || (e.target.closest && e.target.closest('.bmcW2D-dlg__x'))) dlg.close();
      });
      dlg.addEventListener('close', function () { if (last) { try { last.focus({ preventScroll: true }); } catch (e) {} } });
    }
    last = btn;
    var im = dlg.querySelector('img');
    im.src = src;
    im.alt = btn.getAttribute('data-bmcw2d-alt') || '';
    if (typeof dlg.showModal === 'function') { dlg.showModal(); dlg.querySelector('.bmcW2D-dlg__x').focus(); }
    else window.open(src, '_blank', 'noopener');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var play = t.closest('.bmcW2D-vplay');
    if (play) { e.preventDefault(); load(play.closest('[data-bmcw2d-embed]')); return; }
    var z = t.closest('.bmcW2D-zoom');
    if (z) { e.preventDefault(); zoom(z); return; }
    var w = t.closest('a[href="#bmcW2D-v"]');
    if (w) {
      var box = document.getElementById('bmcW2D-v');
      if (!box) return;
      e.preventDefault();
      /* the thumbnail runs Dawn's own switch (desktop shows only the active slide; phones scroll the slider) */
      var th = document.querySelector('[data-target$="-bmcW2Dv"] button');
      if (th && th.offsetParent !== null) th.click();
      else {
        var li = box.closest('li');
        if (li && li.parentElement) li.parentElement.scrollTo({ left: li.offsetLeft });
      }
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(function () {
        box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
        load(box);
      }, 120);
    }
  });
})();
